import { useState } from 'react'
import { MegaMenu } from '../../megaMenu/MegaMenu.mobile'
import { Image } from '@app/components/core/image/Image'
import { NavBarMobile } from '../blocks/NavBar.mobile'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { Style } from 'inlines'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
  navBarStyle?: Style
}

export const TopNavBar = ({
  userName,
  avatar,
  isLoading,
  navBarStyle,
}: TopNavBarProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const tenant = useTenantContext()

  return (
    <NavBarMobile
      userName={userName}
      avatar={avatar}
      isLoading={isLoading}
      onMenuOpen={() => setIsMenuOpen(true)}
      style={navBarStyle}
      logo={
        <Image
          src={tenant.logoUrl}
          alt={`${tenant.title} Logo`}
          resizeWidth={123}
          style={{ height: '100%' }}
        />
      }
    >
      <MegaMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        isAuthenticated={userName !== undefined}
      />
    </NavBarMobile>
  )
}
